import styled from 'styled-components';
import { Button } from '../../../common/components/Button/Button';
import { ThemeColours } from '../../../common/styles/ThemeColours';
import { Breakpoint } from '../../../common/styles/constants';
import { AutoCompleteSuburbFieldWithoutError } from '../../../patient-forms/PatientForm/AutoCompleteFields/AutoCompleteFields';

export const CTAContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  ${Breakpoint.MEDIUM} {
    flex-direction: row;
  }
`;

const BookNowButtonBase = styled(Button)`
  margin-bottom: 50px;
  margin-top: 10px;

  ${Breakpoint.MEDIUM} {
    margin-bottom: 0px;
    margin-left: 10px;
    margin-top: 0px;
    width: 200px;
  }

  &[disabled] {
    pointer-events: none;
  }
`;

export const BookNowButton = styled(BookNowButtonBase)`
  background: ${ThemeColours.accent};

  &[disabled] {
    background: ${ThemeColours.mono100};
    border: 2px solid ${ThemeColours.mono300};
    color: ${ThemeColours.mono800};
  }
`;

export const BookNowButtonFooter = styled(BookNowButtonBase)`
  background: ${ThemeColours.primary700};
  border: 2px solid ${ThemeColours.primaryB};
  color: ${ThemeColours.buttonPrimaryText};

  &[disabled] {
    background: ${ThemeColours.primary700};
    border: 2px solid ${ThemeColours.mono500};
    color: ${ThemeColours.mono500};
  }
`;

export const StyledAutoCompleteSuburbField = styled(AutoCompleteSuburbFieldWithoutError)`
  width: 300px;
`;
